import React, { FC } from 'react';

import { CHATBOT_LULU__URL } from '../../../../../config/config-common';
import FloatingBottomNav from '../../../../components/FloatingBottomNav';
import AppLayout from '../../../../components/layouts/AppLayout';

import useIsMobile from '../../../../hooks/useIsMobile';

import * as Styled from './styled';

export type Props = {
  className?: string;
};

/**
 * Chatbot Lulu page component
 *
 * @param props           The component props
 * @param props.className The class name for the component, provided by styled-components
 * @returns               The page component itself
 */
const PageChatbotLulu: FC<Props> = ({ className }) => {
  const isMobile = useIsMobile();

  return (
    <AppLayout
      className={className}
      footer={isMobile ? <FloatingBottomNav /> : null}
      header={null}
      mainAbsoluteElements={null}
      rightSidebar={null}
    >
      <Styled.Iframe src={CHATBOT_LULU__URL} />
    </AppLayout>
  );
};

export default PageChatbotLulu;
